import { render, staticRenderFns } from "./Bando25Fase2.vue?vue&type=template&id=9afdbe34&scoped=true"
import script from "./Bando25Fase2.vue?vue&type=script&lang=js"
export * from "./Bando25Fase2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9afdbe34",
  null
  
)

export default component.exports